<template>
  <span></span>
</template>
<script>
import filter_rq from './filter_rq';

export default {
  props:['f_key'],
  mixins: [ filter_rq ],
  data(){
    return {
      multiple:true,
      model:null,
      reset_on_value_change:true,
      filter_rq_type:['>'],
    }
  },
  computed: {
    k_f(){ return this.f_key || `s__${this.item_key}` },
  },
  methods: {
    set_model() {
      this.dev_log(this.k_f, this.name,this.value);
      const ex_f = {};
      this.model = null;
      if (Array.isArray(this.value) && this.value.length) this.model = this.item_key? this.value.map(m=>typeof m=='object'?m[this.item_key]:m): this.value;
      if (this.model) ex_f[this.k_f] = this.model;
      /*  */else ex_f[this.k_f] = null;
      this.dev_log('>>',this.model);
      this.dev_log({ex_f});
      this.pre_get(ex_f,this.k_f);
      this.get_rq(ex_f);
    },
    upd(){
      this.dev_log('!!!',this.model);
      this.$emit('update:value', this.model);
    },
    then_get_rows(r) { return r },
  },
};
</script>
